import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AdorHeader from "./components/header/AdorHeader";
import AdorFooter from './components/footer/AdorFooter';
import AppRoutes from './routes';

function App() {
  return (
    <BrowserRouter>
      <AdorHeader />
      <AppRoutes />
      <AdorFooter />
    </BrowserRouter>
  );
}

export default App;